import { LitElement, html, css } from 'lit';
import { Text } from '../Text/Text';
import '../Time/Timestamp';
import '../ReadMark/BlueReadMark/BlueReadMark';
import '../ReadMark/ClockMark/ClockMark';
import '../ReadMark/DoubleMark/DoubleMark';
import '../ReadMark/SingleMark/SingleMark';
import '../MessageBubble/DocumentMessageBubble/DocumentMessageBubble';
import '../EmojiReactions/EmojiReactions.js';
import '../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';

import '../../../components/ChatUIComponent/ReactionContainer.js'
class ForwardMessageContainer extends LitElement {
  static properties = {
    bgColor: { type: String },
    width: { type: String },
    height: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    color: { type: String },
    fontSize: { type: String },
    borderRadius: { type: String },
    fontWeight: { type: String },
    progressBarBg: { type: String },
    progressBarHeight: { type: String },
    progressBarColor: { type: String },
    progressBarBorderRadius: { type: String },
    messageBody: { type: String },
    padding: { type: String },
    isRead: { type: Boolean },
    isDelivered: { type: Boolean },
    time: { type: String },
    messageBodyBg: { type: String },
    messageAttachment: { type: Array },
    isSelf: { type: Boolean },
    messageId: { type: String },
    reactions: { type: Object },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: {type: Boolean},
    showReactionButton: {type: Boolean},
    showEmojiReactions: {type: Boolean},
    userMetaData: {type: Object},
   
  };

  constructor() {
    super();
    this.bgColor = 'white';
    this.width = '200px';
    this.height = 'auto';
    this.borderWidth = '1px';
    this.borderColor = 'black';
    this.color = 'black';
    this.fontSize = '14px';
    this.borderRadius = '5px';
    this.fontWeight = 'normal';
    this.progressBarBg = 'white';
    this.progressBarHeight = '5px';
    this.progressBarColor = 'yellow';
    this.progressBarBorderRadius = '5px';
    this.messageBody = 'Default message';
    this.time = '1733124564435';
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
  }

  static styles = css`
    .forward-message-container {
      display: flex;
      flex-direction: column;
      position: relative;
      width: fit-content;
      max-width: 72% !important;
      align-self: center;
      overflow-wrap: break-word;
      min-width: 200px;
      border-radius: 6px;
      min-width: 100%;
      padding: 0 0 10px;
    }

    .forward-label {
      display: flex;
      align-items: center;
      font-style: italic;
      padding: 5px;
    }

    .forward-label span {
      font-style: italic;
    }

    .forward-message-body {
      padding: 3px 15px;
      margin: 0 6px;
      border-radius: 6px;
    }

    .forward-message-info {
      display: flex;
      align-items: center;
      align-self: end;
      padding: 2px 4px;
      gap: 2px;
    }
        .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      font-size: 20px;
      background: var(--bg-secondary-color);
      cursor: pointer;
    }

       reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }

  `;

  handleMouseEnter() {
    this.showReactionButton = true;
  }

  
  handleReactionRemove(reaction) {
    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }
  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;
    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }


  render() {
    const svgSize = parseInt(this.fontSize) - 2;
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;
    const mediaContent =
      this.messageAttachment && this.messageAttachment.length > 0
        ? this.messageAttachment.map(attachment => {
            if (attachment.mimeType.startsWith('image/')) {
              return html`<img src="${attachment.mediaUrl}" alt="Image attachment" style="width: 250px; height: 220px; object-fit: cover;" />`;
            } else if (attachment.mimeType.startsWith('video/')) {
              return html`<video controls style="width: 250px; height: 220px; object-fit: cover;">
                <source src="${attachment.mediaUrl}" type="${attachment.mimeType}" />
                Your browser does not support the video tag.
              </video>`;
            } else if (attachment.mimeType.startsWith('application/')) {
              return html`<document-message 
                docName="${attachment.fileName}"
                href="${attachment.mediaUrl}"
                fileName="${attachment.fileName}"
                docType="${attachment.mimeType}"
                textColor="${this.color}"
                width="200px"
                bgColor="var(--bg--message)"
              ></document-message>`;
            }
            return null;
          })
        : html`${Text({
            content: this.messageBody,
            color: this.color,
            textAlign: 'left',
          })}`;

    return html`
      <div
       @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        class="forward-message-container"
        style="border: ${this.borderWidth} solid ${this.borderColor};
         background-color: ${this.bgColor}
      "
      >
        ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}

         ${this.showConfirmationPopup
          ? html`
             <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container>
            `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" "> +${remainingCount} </span>
              
              `
            : ''}
        </div>
        <div class="forward-label">
          <svg width="${svgSize}" height="${svgSize}" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_1512_27751" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
              <rect x="0.15625" y="0.21582" width="24" height="24" fill="${this.color}" />
            </mask>
            <g mask="url(#mask0_1512_27751)">
              <path
                d="M19.5333 11.2156L15.4755 7.15783C15.3203 7.00266 15.2428 6.8245 15.2428 6.62333C15.2428 6.422 15.3203 6.24374 15.4755 6.08858C15.6307 5.94374 15.8105 5.87291 16.015 5.87608C16.2193 5.87941 16.3908 5.95024 16.5293 6.08858L21.0235 10.5828C21.1172 10.6765 21.1832 10.7752 21.2215 10.8791C21.26 10.9829 21.2792 11.0951 21.2792 11.2156C21.2792 11.3361 21.26 11.4482 21.2215 11.5521C21.1832 11.6559 21.1172 11.7547 21.0235 11.8483L16.5293 16.3426C16.3741 16.4976 16.1985 16.5726 16.0025 16.5676C15.8063 16.5624 15.6307 16.4874 15.4755 16.3426C15.3203 16.1874 15.2418 16.0102 15.24 15.8108C15.238 15.6115 15.3113 15.4374 15.46 15.2886L19.5333 11.2156ZM14.2255 11.9656H7.40625C6.50875 11.9656 5.74275 12.2829 5.10825 12.9176C4.47358 13.5521 4.15625 14.3181 4.15625 15.2156V17.9656C4.15625 18.1784 4.08442 18.3566 3.94075 18.5001C3.79725 18.6437 3.61908 18.7156 3.40625 18.7156C3.19342 18.7156 3.01525 18.6437 2.87175 18.5001C2.72808 18.3566 2.65625 18.1784 2.65625 17.9656V15.2156C2.65625 13.9027 3.11975 12.7829 4.04675 11.8561C4.97358 10.9291 6.09342 10.4656 7.40625 10.4656H14.2255L10.9178 7.15783C10.7628 7.00266 10.6853 6.8245 10.6853 6.62333C10.6853 6.422 10.7628 6.24374 10.9178 6.08858C11.0729 5.94374 11.2528 5.87291 11.4573 5.87608C11.6618 5.87941 11.8333 5.95024 11.9718 6.08858L16.4658 10.5828C16.5594 10.6765 16.6255 10.7752 16.664 10.8791C16.7025 10.9829 16.7218 11.0951 16.7218 11.2156C16.7218 11.3361 16.7025 11.4482 16.664 11.5521C16.6255 11.6559 16.5594 11.7547 16.4658 11.8483L11.9718 16.3426C11.8166 16.4976 11.6409 16.5726 11.4448 16.5676C11.2486 16.5624 11.0729 16.4874 10.9178 16.3426C10.7628 16.1874 10.6843 16.0102 10.6823 15.8108C10.6803 15.6115 10.7537 15.4374 10.9025 15.2886L14.2255 11.9656Z"
                fill="${this.color}"
              />
            </g>
          </svg>
          <span style="color: ${this.color};font-size: ${parseInt(this.fontSize) - 2}px">forwarded</span>
        </div>
        <div class="forward-message-body" style="font-size: ${this.fontSize}; background-color: ${this.messageBodyBg}">${mediaContent}</div>
        <div class="forward-message-info">
          <div><timestamp-element .color="${this.color}" .time="${this.time || new Date().toISOString()}"></timestamp-element></div>
          ${this.isSelf
            ? this.isRead == true
              ? html`<blue-read-mark svgFillColor="${this.color}"></blue-read-mark>`
              : this.isDelivered == 'true'
                ? html`<double-mark svgFillColor="${this.color}"></double-mark>`
                : this.isDelivered == 'pending'
                  ? html`<clock-mark svgFillColor="${this.color}"></clock-mark>`
                  : html`<single-mark></single-mark>`
            : null}
        </div>
      </div>
    `;
  }
}

customElements.define('forward-message', ForwardMessageContainer);
